import {
    orgGuBookedOnDate,
    orgGuBookingList,
    orgGuDashboardData,
    orgGudashFun,
    orgGuidBookingCount,
    orgGuSlotBookings
} from '../../../../api/orgGuidAPI';
import errorHandle from '../../../../utils/errorHandle';

export const fetchGuideDashboardBookingsData = async (
    setTableData,
    setTotalCount,
    setKpiData,
    setLoading,
    selected,
    bookingsOnly,
    limit,
    offset
) => {
    setLoading(true);
    try {
        const response = await orgGuDashboardData(selected, bookingsOnly, offset, limit);
        console.log(response.data);
        setTableData(response.data.data);
        setTotalCount(response.data.totalCount);
        setKpiData(response.data.stats);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchGuideDashboardKpiData = async (setTotalCount, setLoading) => {
    setLoading(true);
    try {
        const response = await orgGudashFun();
        setTotalCount(response.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchGuideDashboardBookingsCount = async (setTotalCount, setLoading, selected) => {
    setLoading(true);
    try {
        const response = await orgGuidBookingCount(selected, '');
        setTotalCount(response.data.bookCount);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchGuBookedOnDate = async (guTourId, slotId, setGuDateDetails, setSlotDetails, setLoading) => {
    setLoading(true);
    try {
        const response = await orgGuSlotBookings(guTourId, slotId);
        setGuDateDetails(response.data.data);
        setSlotDetails(response.data.slot);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
